
import type { ModifyParams, SaleType } from 'app/dataTypes/dishes/saleType'
import type { Request } from '../../../index'


type ApiParams = {
  id: number
  title: string
}

export const convertParams = ({ title, id }: ModifyParams): [ApiParams, null] => {
  return [{ title, id: parseInt(id, 10) }, null]
}

type ApiResult = { id: number, title: string, reserved: boolean }

export const convertResult = (data: ApiResult): SaleType => {
  const { id, title, reserved } = data
  return {
    id: String(id),
    title,
    reserved,
  }
}

export const PUT_SALE_TYPE: Request<
  ModifyParams,
  SaleType,
  null
> = [
  'food/items/sale_types',
  'put',
  ['data', 'sale_types'],
]
